export default {
    responseTimeout: 10000,
    remote: {
        isEnabled: false,
        url: 'http://server-url.com/app'
    }
}

